import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "User Shield Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M225.92 319.963c96.564 0 156.916-104.533 108.634-188.16-22.407-38.811-63.819-62.72-108.634-62.72-96.564 0-156.916 104.534-108.634 188.16 22.407 38.812 63.819 62.72 108.634 62.72m-44.786 47.04C84.604 367.003 6.4 445.207 6.4 541.737c0 16.072 13.034 29.106 29.106 29.106h380.828c1.764 0 3.43-.196 5.194-.49-74.774-53.998-97.804-138.18-101.038-196.196-15.778-4.704-32.438-7.154-49.686-7.154zm302.624-76.734-117.6 47.04c-8.918 3.626-14.798 12.25-14.798 21.854 0 62.034 25.382 165.424 132.104 209.916a23.28 23.28 0 0 0 18.13 0C608.218 524.587 633.6 421.197 633.6 359.163c0-9.604-5.88-18.228-14.798-21.854l-117.6-47.04a23.35 23.35 0 0 0-17.444 0m102.214 84.574C582.15 424.53 559.316 489.21 492.48 521.55V337.407z"
    }, null, -1)
  ])))
}
export default { render: render }